<template>
  <div class="outer-container">
    <div class="container">
      <div class="row">
        <div class="col-6  left-heading">
          <h2 class="manrope  custom-black">
            Your first step towards becoming a <br />
            <span style="color:#B70000">
              Junior Product Manager
            </span>
          </h2>
          <h5>
            Upskill presents an assessment designed specifically for the Junior
            Product Manager position. Take part in the assessment, and get a
            chance to work at LightCastle Partners (LCP). Based on experience,

            <span class="bold">
              salary will range from Tk 40k-65k.
            </span>
          </h5>

          <img
            :src="landingData.companyLogo"
            alt=""
            style="max-width:145px; padding-top:20px"
          />
          <a :href="landingData.quizLink" class="btn">
            Apply now
          </a>
        </div>

        <div class="col-6  right-image">
          <img :src="landingData.landingImage" alt="" />
        </div>
      </div>
    </div>

    <div style="background-color:#ECECEC;">
      <div class="grid container">
        <div class="flexing">
          <a href="#about">
            <h3>
              About the Company
            </h3>
          </a>
        </div>

        <div class="flexing">
          <a href="#program">
            <h3>
              Program Structure
            </h3>
          </a>
        </div>

        <div class="flexing">
          <a href="#faq">
            <h3>
              FAQ
            </h3>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    landingData: {
      type: Object,
      required: true,
    },
  },
}
</script>
<style scoped>
.header-font {
  font: 800 2.25rem/2.75rem 'Manrope';
  color: #29292b;
}
.row {
  margin-bottom: 100px;
}
.container {
  max-width: 1300px !important;
}
.outer-container {
  background: white;
  opacity: 1;
}
.left-heading {
  padding-top: 40px;
  display: flex;

  flex-direction: column;
  justify-content: center;
  max-height: 750px;
}

.left-heading h2 {
  font-family: 'Manrope';
  font-size: 55px;
  font-weight: 800;
  letter-spacing: -2px;
  line-height: 60px;
  color: #29292b;
  padding-top: 10px;
}
.left-heading h6 {
  font-family: 'Open Sans';

  font-size: 18px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 24px;
  color: #3c4663;
}
.left-heading h5 {
  font-family: 'Manrope';
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 24px;
  color: #84888b;
  padding-top: 20px;
  /* padding-bottom: 45px; */
}
.left-heading h2 span {
  font-family: 'Manrope';

  font-size: 55px;
  font-weight: 800;
  letter-spacing: -3.6px;
  line-height: 60px;
  color: #d21e28;
}
.left-heading h6 {
  padding-top: 36px;
  padding-bottom: 0;
  letter-spacing: 0px;
  color: #ff165d;
  font-family: 'Open Sans';
  font-size: 18px;
  font-weight: 600;
}
.right-image {
  padding-top: 50px;
  max-height: 568px;
  display: flex;
  align-items: flex-end;
  flex-direction: column;
}
.right-image img {
  max-height: 568px;
  display: flex;
  align-items: flex-end;
}
.right-image-social {
  display: flex;

  align-items: flex-end;
  padding-bottom: 25px;
  padding-top: 45px;
}
.right-image-social img {
  color: #ff165d !important;
}
.btn {
  margin-top: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #2465f3 !important;
  text-align: center;
  max-width: 240px;
  min-height: 65px;
  color: white;
  cursor: pointer;
}
a {
  text-transform: capitalize;
  font-family: 'Manrope';
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 0px;
  line-height: 24px;
}
.banner-bottom {
  padding-top: 54px;
  padding-bottom: 50px;
  padding-left: 50px;
  padding-right: 50px;
}
.flexing {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0px 10px;
}
.banner-bottom h2 {
  /* text-transform: uppercase; */
  font-family: 'Open Sans';
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 7.2px;
  line-height: 24px;
  color: #ffffff;
}
.grid {
  padding: 25px 0;
  display: flex;
  justify-content: space-evenly;
}
.grid h3 {
  font: 800 1rem/1.25rem 'Manrope';
  color: #2465f3;
  margin-bottom: 0px;
  padding-bottom: 0px;
}
.border-bottom h2 {
  border-bottom: 1px solid white;
  padding-bottom: 15px;
}
.grid h4 {
  text-transform: uppercase;
  font-family: 'Open Sans';
  font-size: 60px;
  font-weight: 300;
  letter-spacing: 0px;
  line-height: 24px;
  color: #ffffff;
}
.flex {
  display: inline-flex;
}
.flex .left {
  margin-right: 20px;
}
.logo-im {
  max-width: 160px;
  max-height: 63px;
}
@media only screen and (min-width: 601px) and (max-width: 1100px) {
  a {
    color: black;
  }
  .grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }

  .banner-bottom h2 {
    text-transform: uppercase;

    font-size: 16px;

    letter-spacing: 6.4px;
    line-height: 24px;
  }
  .banner-bottom {
    padding-top: 54px;
    padding-bottom: 50px;
    padding-left: 20px;
    padding-right: 20px;
  }
  .right-image-social {
    display: none;
  }

  .left-heading img {
    max-width: 150px;
    max-height: 60px;
    margin-left: -15px;
  }
  .col-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-5 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .right-image img {
    margin-top: 100px;
    padding-top: 0px;
    max-width: 100%;
    max-height: 325px;
    display: flex;
    align-items: flex-end;
  }
  .left-heading h2 {
    font-size: 30px;

    letter-spacing: -1.5px;
    line-height: 35px;
  }
  .left-heading h2 span {
    font-size: 30px;

    letter-spacing: -1.5px;
    line-height: 35px;
  }
  .left-heading h5 {
    padding-top: 15px;
    padding-bottom: 25px;
  }
  .btn {
    text-align: center;
    max-width: 80%;
    height: 50px;
    border-radius: 0;
    margin-bottom: 15px;
    width: 100%;
  }
  /* .position input[type="radio"]:checked+label { font-weight: bold;
  border: 3px solid #FFC600;
  } */

  .left-heading {
    padding-top: 55px;
    display: flex;
    padding-left: 12px;
    padding-right: 12px;

    flex-direction: column;
    justify-content: flex-end;
    max-height: 750px;
  }
}
@media only screen and (max-width: 600px) {
  .flexing {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 8px 10px;
  }
  .left-heading span::before {
    padding-left: 10px;
  }
  .grid {
    padding-top: 20px;
    display: grid;
    grid-template-columns: repeat(1, 1fr);
  }
  .grid h4 {
    font-size: 20px;
    font-weight: 700;
  }
  .banner-bottom h2 {
    text-transform: uppercase;

    font-size: 16px;

    letter-spacing: 6.4px;
    line-height: 24px;
  }
  .banner-bottom {
    padding-top: 54px;
    padding-bottom: 50px;
    padding-left: 20px;
    padding-right: 20px;
  }
  .right-image-social {
    display: none;
  }
  .row {
    display: flex;
    flex-direction: column;
  }
  .left-heading img {
    max-width: 150px;
    max-height: 60px;
    margin-left: 0px;
  }
  .col-6 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .col-5 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .right-image img {
    padding-top: 0px;
    max-width: 100%;
    display: flex;
    align-items: flex-end;
  }
  .left-heading h2 {
    font-size: 30px;

    letter-spacing: -1.5px;
    line-height: 35px;
  }
  .left-heading h2 span {
    font-size: 30px;

    letter-spacing: -1.5px;
    line-height: 35px;
  }
  .left-heading h5 {
    padding-top: 15px;
    padding-bottom: 25px;
  }
  .left-heading h5 {
    font-size: 18px;

    letter-spacing: 0px;
    line-height: 24px;

    padding-top: 10px;
    padding-bottom: 5px;
  }
  .btn {
    background-color: #035bf4;
    text-align: center;
    max-width: 100%;
    height: 60px;
    border-radius: 0;
    margin-bottom: 15px;
    width: 100%;
    border-radius: 4px;
  }

  .left-heading {
    padding-top: 20px;
    display: flex;
    padding-left: 12px;
    padding-right: 12px;

    flex-direction: column;
    justify-content: flex-end;
    max-height: 750px;
  }
  /* .left-heading{
    width: 100%;
    order: 1;
  } */
}

@media only screen and (max-width: 410px) {
  .left-heading h2 {
    font-size: 24px;

    letter-spacing: -1.5px;
    line-height: 30px;
  }
  .left-heading h2 span {
    font-size: 24px;

    letter-spacing: -1.5px;
    line-height: 30px;
  }
  .left-heading h5 {
    font-size: 14px;

    letter-spacing: 0px;
    line-height: 24px;

    padding-top: 10px;
    padding-bottom: 5px;
  }

  .left-heading {
    padding-top: 5px;
  }
}
</style>
